var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5171 11.0245L15 14.5074L13.9129 15.5946L10.3706 12.0522C9.40928 12.714 8.24734 13.1009 6.99585 13.1009C3.68443 13.1009 1 10.392 1 7.05046C1 3.70889 3.68443 1 6.99585 1C10.3073 1 12.9917 3.70889 12.9917 7.05046C12.9917 8.57153 12.4355 9.96149 11.5171 11.0245ZM11.4547 7.05135C11.4547 9.53611 9.45861 11.5504 6.99627 11.5504C4.53394 11.5504 2.53782 9.53611 2.53782 7.05135C2.53782 4.56658 4.53394 2.55228 6.99627 2.55228C9.45861 2.55228 11.4547 4.56658 11.4547 7.05135Z",
    fill: "#9299A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b25e171b8bb1fd1fbe14530b67978312.svg";
export { ForwardRef as ReactComponent };